import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
   ListItemButton,
    Link,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  MenuItem,
  Card,
  CardContent
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold',
    whiteSpace: 'nowrap'
  }
});

const AgeGroupRow = styled(TableRow)({
  backgroundColor: '#f0f0f0',
  fontWeight: 'bold'
});

const SubGroupRow = styled(TableRow)({
  backgroundColor: '#f9f9f9'
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données
const ageGroupData = {
  title: "Répartition de la population des ménages ordinaires par groupe d'âges fonctionnels (éducation) selon le sexe et le milieu de résidence",
  data: [
    {
      ageGroup: "3 - 5 ans",
      total: "1 197 238",
      sex: {
        male: "602 193",
        female: "595 045"
      },
      urban: {
        total: "258 781",
        sex: {
          male: "130 509",
          female: "128 272"
        }
      },
      rural: {
        total: "938 457",
        sex: {
          male: "471 684",
          female: "466 773"
        }
      }
    },
    {
      ageGroup: "6 -14 ans",
      total: "3 065 878",
      sex: {
        male: "1 531 150",
        female: "1 534 728"
      },
      urban: {
        total: "668 134",
        sex: {
          male: "328 330",
          female: "339 804"
        }
      },
      rural: {
        total: "2 397 744",
        sex: {
          male: "1 202 820",
          female: "1 194 924"
        }
      },
      subGroups: [
        {
          ageGroup: "6-7 ans",
          total: "722 454",
          sex: {
            male: "363 157",
            female: "359 297"
          },
          urban: {
            total: "158 306",
            sex: {
              male: "79 790",
              female: "78 516"
            }
          },
          rural: {
            total: "564 148",
            sex: {
              male: "283 367",
              female: "280 781"
            }
          }
        },
        {
          ageGroup: "8-9 ans",
          total: "694 969",
          sex: {
            male: "348 127",
            female: "346 842"
          },
          urban: {
            total: "151 183",
            sex: {
              male: "75 705",
              female: "75 478"
            }
          },
          rural: {
            total: "543 786",
            sex: {
              male: "272 422",
              female: "271 364"
            }
          }
        },
        {
          ageGroup: "10-11 ans",
          total: "636 911",
          sex: {
            male: "319 493",
            female: "317 418"
          },
          urban: {
            total: "137 526",
            sex: {
              male: "67 886",
              female: "69 640"
            }
          },
          rural: {
            total: "499 385",
            sex: {
              male: "251 607",
              female: "247 778"
            }
          }
        },
        {
          ageGroup: "12-14 ans",
          total: "1 011 544",
          sex: {
            male: "500 373",
            female: "511 171"
          },
          urban: {
            total: "221 119",
            sex: {
              male: "104 949",
              female: "116 170"
            }
          },
          rural: {
            total: "790 425",
            sex: {
              male: "395 424",
              female: "395 001"
            }
          }
        }
      ]
    },
    {
      ageGroup: "15-17 ans",
      total: "856 325",
      sex: {
        male: "409 810",
        female: "446 515"
      },
      urban: {
        total: "211 863",
        sex: {
          male: "99 097",
          female: "112 766"
        }
      },
      rural: {
        total: "644 462",
        sex: {
          male: "310 713",
          female: "333 749"
        }
      }
    },
    {
      ageGroup: "18-21 ans",
      total: "898 713",
      sex: {
        male: "402 462",
        female: "496 251"
      },
      urban: {
        total: "254 847",
        sex: {
          male: "121 766",
          female: "133 081"
        }
      },
      rural: {
        total: "643 866",
        sex: {
          male: "280 696",
          female: "363 170"
        }
      }
    }
  ],
  total: {
    total: "7 018 054",
    sex: {
      male: "3 447 075",
      female: "3 570 979"
    },
    urban: {
      total: "1 653 725",
      sex: {
        male: "800 408",
        female: "853 317"
      }
    },
    rural: {
      total: "5 364 329",
      sex: {
        male: "2 646 667",
        female: "2 717 662"
      }
    }
  }
};

const PopulationByAgeGroupPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const filteredData = ageGroupData.data.filter(group =>
  group.ageGroup.toLowerCase().includes(searchTerm.toLowerCase())
);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleGroup = (groupName) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupName]: !prev[groupName]
    }));
  };
 // Calcul des indicateurs clés
const keyStats = {
  totalPopulation: ageGroupData.total.total,
  urbanPercentage: (
    parseFloat(ageGroupData.total.urban.total.replace(/\s/g, '')) /
    parseFloat(ageGroupData.total.total.replace(/\s/g, '')) * 100
  ).toFixed(1),
  ruralPercentage: (
    parseFloat(ageGroupData.total.rural.total.replace(/\s/g, '')) /
    parseFloat(ageGroupData.total.total.replace(/\s/g, '')) * 100
  ).toFixed(1),
  largestAgeGroup: ageGroupData.data.reduce((max, group) =>
    parseFloat(group.total.replace(/\s/g, '')) >
    parseFloat(max.total.replace(/\s/g, '')) ? group : max
  ),
  highestGenderGap: ageGroupData.data.reduce((max, group) => {
    const gap = Math.abs(
      (parseFloat(group.sex.male.replace(/\s/g, '')) -
        parseFloat(group.sex.female.replace(/\s/g, ''))) /
      parseFloat(group.total.replace(/\s/g, '')) * 100
    );
    return gap > max.gap ? { group, gap } : max;
  }, { group: null, gap: 0 }),
  educationAgeGroupsTotal: ageGroupData.data
    .filter(group =>
      group.ageGroup === "3 - 5 ans" || group.ageGroup === "6 -14 ans")
    .reduce((sum, group) =>
      sum + parseFloat(group.total.replace(/\s/g, '')), 0)
};



  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );


  return (
     <MainContainer>
          <CssBaseline />
          <NavigationBar />
          <MainContentWithDrawer>
            {!isMobile ? (
              <DrawerWrapper>
                {drawer}
              </DrawerWrapper>
            ) : (
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true,
                }}
                sx={{
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
              >
                {drawer}
              </Drawer>
            )}
    
            <ContentWrapper>
              <Container maxWidth="lg">
                {isMobile && (
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                    <Button 
                      variant="outlined" 
                      startIcon={<MenuIcon />} 
                      onClick={handleDrawerToggle}
                      sx={{ color: primaryColor, borderColor: primaryColor }}
                    >
                      Menu
                    </Button>
                  </Box>
                )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {ageGroupData.title}
                    </Typography>
                  </Box>
                     <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                          <Grid item xs={12} sm={6} md={6} ></Grid>
                          <Grid item xs={12} sm={6} md={6}>
                          <TextField
                               size="small"
                               placeholder="Rechercher groupe d'âge..."
                               variant="outlined"
                               value={searchTerm}
                               onChange={(e) => setSearchTerm(e.target.value)}
                               InputProps={{
                                  startAdornment: (
                                   <InputAdornment position="start">
                                    <Search />
                                    </InputAdornment>
                                  ),
                                }}
                              sx={{ width: { xs: '100%', sm: '480px' } }}
                            />
                           </Grid>
                        </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Totale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {ageGroupData.total.total}
                              </Typography>
                              <Typography variant="caption">
                                Ménages ordinaires
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population urbaine
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.urbanPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                {ageGroupData.total.urban.total} personnes
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population rurale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.ruralPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                {ageGroupData.total.rural.total} personnes
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Groupe d'âge le plus important
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.largestAgeGroup.ageGroup}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.largestAgeGroup.total}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Groupe d'âge</TableCell>
                          <TableCell colSpan={3} align="center">Ensemble</TableCell>
                          <TableCell colSpan={3} align="center">Milieu urbain</TableCell>
                          <TableCell colSpan={3} align="center">Milieu rural</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total */}
                        <AgeGroupRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            TOTAL
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupData.total.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupData.total.sex.male}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupData.total.sex.female}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupData.total.urban.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupData.total.urban.sex.male}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupData.total.urban.sex.female}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupData.total.rural.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupData.total.rural.sex.male}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupData.total.rural.sex.female}</TableCell>
                        </AgeGroupRow>

                        {/* Données par groupe d'âge */}
                        {filteredData.map((group, index) => (
                          <React.Fragment key={index}>
                            <AgeGroupRow 
                              hover 
                              onClick={() => group.subGroups && toggleGroup(group.ageGroup)}
                              sx={{ cursor: group.subGroups ? 'pointer' : 'default' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {group.subGroups && (expandedGroups[group.ageGroup] ? <ExpandLess /> : <ExpandMore />)}
                                  {group.ageGroup}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{group.total}</TableCell>
                              <TableCell align="right">{group.sex.male}</TableCell>
                              <TableCell align="right">{group.sex.female}</TableCell>
                              <TableCell align="right">{group.urban.total}</TableCell>
                              <TableCell align="right">{group.urban.sex.male}</TableCell>
                              <TableCell align="right">{group.urban.sex.female}</TableCell>
                              <TableCell align="right">{group.rural.total}</TableCell>
                              <TableCell align="right">{group.rural.sex.male}</TableCell>
                              <TableCell align="right">{group.rural.sex.female}</TableCell>
                            </AgeGroupRow>
                            
                            {group.subGroups && (
                              <TableRow>
                                <TableCell style={{ padding: 0 }} colSpan={10}>
                                  <Collapse in={expandedGroups[group.ageGroup] || !!searchTerm} timeout="auto" unmountOnExit>
                                    <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                      <TableBody>
                                        {group.subGroups.map((subGroup, idx) => (
                                          <SubGroupRow key={idx} hover>
                                            <TableCell sx={{ pl: 6 }}>{subGroup.ageGroup}</TableCell>
                                            <TableCell align="right">{subGroup.total}</TableCell>
                                            <TableCell align="right">{subGroup.sex.male}</TableCell>
                                            <TableCell align="right">{subGroup.sex.female}</TableCell>
                                            <TableCell align="right">{subGroup.urban.total}</TableCell>
                                            <TableCell align="right">{subGroup.urban.sex.male}</TableCell>
                                            <TableCell align="right">{subGroup.urban.sex.female}</TableCell>
                                            <TableCell align="right">{subGroup.rural.total}</TableCell>
                                            <TableCell align="right">{subGroup.rural.sex.male}</TableCell>
                                            <TableCell align="right">{subGroup.rural.sex.female}</TableCell>
                                          </SubGroupRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </Collapse>
                                </TableCell>
                              </TableRow>
                            )}
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* 
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des groupes d'âges fonctionnels
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Les groupes d'âges fonctionnels sont définis selon les besoins spécifiques en matière d'éducation:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• 3-5 ans: Éducation préscolaire" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• 6-14 ans: Enseignement fondamental (primaire)" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• 15-17 ans: Premier cycle du secondaire" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• 18-21 ans: Deuxième cycle du secondaire" 
                        />
                      </ListItem>
                    </List>
                 <Typography variant="body2" mt={2}>
  Ces données montrent que {keyStats.educationAgeGroupsTotal.toLocaleString()} personnes sont en âge de scolarité obligatoire (3-14 ans), 
  représentant {((keyStats.educationAgeGroupsTotal / parseFloat(ageGroupData.total.total.replace(/\s/g, '')) * 100).toFixed(1))}% de la population totale.
</Typography>

                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et de l'Elevage (RGPHAE) 
                    réalisé en 2024. Elles concernent exclusivement les ménages ordinaires. Les groupes d'âges ont été établis selon la classification 
                    standard utilisée par le Ministère de l'Éducation. Les proportions sont calculées par rapport au total national de chaque groupe.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer>
  );
};

export default PopulationByAgeGroupPage;